import { useMemo, useCallback } from 'react';
import { useWidgetsQuery, Widget } from 'graphql-common';

interface UseWidgetsProps {
  homePageId?: string;
}

interface UseWidgetsReturn {
  widgets: Widget[];
  widgetsLoading: boolean;
  widgetsError: ReturnType<typeof useWidgetsQuery>['error'];
  refetchWidgets: () => ReturnType<
    ReturnType<typeof useWidgetsQuery>['refetch']
  >;
}

export default function useWidgets({
  homePageId = '',
}: UseWidgetsProps): UseWidgetsReturn {
  const {
    data: widgetsData,
    loading: widgetsLoading,
    error: widgetsError,
    refetch,
  } = useWidgetsQuery({
    skip: !homePageId,
    fetchPolicy: 'cache-first',
    variables: {
      homePageId,
    },
  });

  const widgets = useMemo(() => {
    const data = widgetsData?.data;
    return Array.isArray(data) ? (data as Widget[]) : [];
  }, [widgetsData]);

  const refetchWidgets = useCallback(() => {
    return refetch();
  }, [refetch]);

  return {
    widgets,
    widgetsLoading,
    widgetsError,
    refetchWidgets,
  };
}
